import { useMainStore } from '@/stores/landing/main.js'

export default function useBreakpoints() {
	const mainStore = useMainStore()
	const htmlComputedStyle = getComputedStyle(document.documentElement)

	;['md', 'xl'].forEach((item) => {
		const value = parseFloat(htmlComputedStyle.getPropertyValue(`--breakpoint-${item}`))

		mainStore.setBreakpoint(item, value)
	})
}
